<div *ngIf="isLoading" class="ui basic segment loading"></div>
<ng-container *ngIf="!isLoading">
    <app-header *ngIf="!addedEmployeeCount" title="self-serve.addYourTeam.addEmployees.addYourTeam"></app-header>
    <app-header
        *ngIf="addedEmployeeCount === 1"
        title="self-serve.addYourTeam.addEmployees.wellDoneYouHaveAdded1"
    ></app-header>
    <app-header
        *ngIf="addedEmployeeCount > 1"
        [title]="
            'self-serve.addYourTeam.addEmployees.wellDoneYouHaveAddedMany' | translate: { number: addedEmployeeCount }
        "
    >
    </app-header>

    <div class="new-employee-links margin-top-8">
        <ui-card variant="dark" [clickable]="true" role="link" [routerLink]="'new'">
            <h3 class="margin-bottom-1">{{ 'self-serve.addYourTeam.addEmployees.addEmployee' | translate }}</h3>
            <p class="text-color-secondary-font">
                {{ 'self-serve.addYourTeam.addEmployees.addEmployeeDetails' | translate }}
            </p>
        </ui-card>
    </div>

    <app-table
        *ngIf="table"
        [table]="table"
        (menuItemSelected)="menuAction($event)"
        [isResponsive]="true"
        [showOffset]="true"
        [noPadding]="true"
        [embedded]="true"
    >
        <app-empty-state label="employees.directory.noEmployeesFound" src="/assets/illustrations/magnifying-glass.png">
        </app-empty-state>
    </app-table>
</ng-container>
